import type { DbClient } from '@fintree/supabase/db-client'
import { defaultDbClient } from '@fintree/supabase/db-client'

/** Phones that belong to non-deleted students. */
export async function phonesWithActiveStudents(
  phones: string[],
  client: DbClient = defaultDbClient
): Promise<Set<string>> {
  const unique = [...new Set(phones.filter(Boolean))]
  if (!unique.length) return new Set()

  const { data, error } = await client.from('students').select('phone').in('phone', unique).is('deleted_at', null)
  if (error) throw error
  return new Set((data ?? []).map((row) => row.phone))
}

export async function filterRowsByActiveStudentPhones<T extends { phone: string | null }>(
  rows: T[],
  client: DbClient = defaultDbClient
): Promise<T[]> {
  if (!rows.length) return []
  const active = await phonesWithActiveStudents(
    rows.map((row) => row.phone).filter((p): p is string => Boolean(p)),
    client
  )
  return rows.filter((row) => !row.phone || active.has(row.phone))
}
